import React, {useState, useContext} from 'react'
import {UserContext} from '../Context/UserContext'
import {
    Row,
    Container,
    Col,
    Input,
    Button,
    InputGroup,
    InputGroupAddon
  } from "reactstrap";
  import { toast } from "react-toastify";
  import Axios from "axios"
  import UserCard from '../Components/UserCard'
  import Repos from '../Components/Repos'
  import { Redirect } from "react-router-dom";



const Home = () => {
    const context = useContext(UserContext);
    const [query, setQuery] = useState("");
    const [user, setUser] = useState(null);
    const fetchUser = async () => {
        try{
            const {data} = await Axios.get(`https://api.github.com/users/${query}`)
            setUser(data)
            console.log(data);
        }
        catch(error){
            toast("Not Able to locate user", {type: "error"});

        }
    }
    if(!context.user?.uid){
        return <Redirect to="/login" />
    }
    return (
        <Container>
      <Row className=" mt-3">
        <Col md="5">
          <InputGroup>
            <Input
              type="text"
              value={query}
              onChange={(e)=> setQuery(e.target.value)}
              placeholder="Please provide the username"
            />
            <InputGroupAddon addonType="append">
              <Button color="primary" onClick={fetchUser}>Fetch User</Button>
            </InputGroupAddon>
          </InputGroup>
          {user ?<UserCard user={user} /> : null}
          
        </Col>
        <Col md="7">{user? <Repos repos_url={user.repos_url} /> : null}</Col>
      </Row>
    </Container>
    )
}

export default Home
